import httpRequest from '../request/indexBase'

// 报告检索
export function reportPage(params) {
  return httpRequest.get({
    url: `/weaviate/crawled-report/page?current=${params.current}&size=${params.size}&queryType=${params.queryType}`
  })
}
// 收藏
export function saveReportCollect(data) {
  console.log('data11', data)
  return httpRequest.post({
    url: `/weaviate/report-collect/saveReportCollect`,
    data
  })
}

// 取消收藏
export function cancelReportCollect(data) {
  console.log('data', data)
  return httpRequest.post({
    url: `/weaviate/report-collect/cancelReportCollect`,
    data
  })
}

// 查询套餐列表
export function getPackageInfoByType(params) {
  return httpRequest.get({
    url: `/payment/package-info/getPackageInfoByType`,
    params
  })
}
// 创建支付订单，返回支付链接
export function createOrder(params) {
  return httpRequest.get({
    url: `/payment/user-package-info/createOrder`,
    params
  })
}

// 查询支付状态
export function queryOrderStatus(params) {
  return httpRequest.get({
    url: `/payment/user-package-info/queryOrderStatus`,
    params
  })
}
// 查询用户签到数据列表
export function getUserSignInList(params) {
  return httpRequest.get({
    url: `/user/user-sign-in/getUserSignInList`,
    params
  })
}
// 用户签到
export function userSignIn(data) {
  return httpRequest.post({
    url: `/user/user-sign-in/userSignIn`,
    data
  })
}
// 根据id查询用户信息
export function detailData(params) {
  return httpRequest.get({
    url: `/sys-user/queryUserId/${params.id}`
  })
}
// 查询用户赠送积分
export function getUserGiftPoints(params) {
  return httpRequest.get({
    url: `/payment/user-package-info/getUserGiftPoints`,
    params
  })
}
// 查询个人、团队-企业购买积分
export function getPurchasedPoints(params) {
  return httpRequest.get({
    url: `/payment/user-package-info/getPurchasedPoints`,
    params
  })
}
// 保存或修改积分消耗限额
export function saveOrUpdatePointsLimit(data) {
  return httpRequest.post({
    url: `/points/points-limit/saveOrUpdatePointsLimit`,
    data
  })
}
// 查询积分消耗限额
export function getPointsLimit(params) {
  return httpRequest.get({
    url: `/points/points-limit/getPointsLimit`,
    params
  })
}
// 查询团队成员积分消耗限额
export function getTeamQuotaConfig(params) {
  return httpRequest.get({
    url: `/points/team-points-quota-config/getTeamQuotaConfig`,
    params
  })
}
// 保存或修改团队成员积分消耗限额
export function saveOrUpdateConfig(data) {
  return httpRequest.post({
    url: `/points/team-points-quota-config/saveOrUpdateConfig`,
    data
  })
}

// 发送邮箱验证码
export function sendEmailVerifyCode(data) {
  return httpRequest.post({
    url: `message/sendEmailVerifyCode`,
    data
  })
}
export function updateUserInfo(data) {
  return httpRequest.put({
    url: `/sys-user/updateUserInfo`,
    data
  })
}
// 团队中心创建团队
export function createTeam(data) {
  return httpRequest.post({
    url: `/permission/team/createTeam`,
    data
  })
}
// 修改团队表实体
export function updateTeam(data) {
  return httpRequest.put({
    url: `/permission/team`,
    data
  })
}
// 修改团队用户表实体
export function updateTeamUser(data) {
  return httpRequest.put({
    url: `/permission/team-user`,
    data
  })
}

// 查询用户团队列表
export function queryTeam(params) {
  return httpRequest.get({
    url: `/permission/team/getTeamListByUserId`,
    params
  })
}
// 查询用户团队列表
export function getTeamListByUserId(params) {
  return httpRequest.get({
    url: `/permission/team/getTeamListByUserId`,
    params
  })
}

// 查询团队表实体
export function permissionTeam(params) {
  return httpRequest.get({
    url: `/permission/team/${params.id}`
  })
}

// 解散团队
export function dissolveTeam(params) {
  return httpRequest.get({
    url: `/permission/team/dissolveTeam`,
    params
  })
}
// 修改成员分组
export function switchGroups(data) {
  return httpRequest.post({
    url: `/permission/team-user/switchGroups`,
    data
  })
}
// 查询用户分组列表
export function getTeamGroupVoList(data) {
  return httpRequest.get({
    url: `/permission/team-group/getTeamGroupVoList?teamId=${data.teamId}&current=${data.current}&size=${data.size}`
  })
}
// 查询用户分组列表 携带groupName
export function getAllTeamGroupList(data) {
  return httpRequest.get({
    url: `/permission/team-group/getAllTeamGroupList?teamId=${data.teamId}&current=${data.current}&size=${data.size}&groupName=${data.groupName}`
  })
}
// 创建用户组
export function teamGroup(data) {
  return httpRequest.post({
    url: `/permission/team-group`,
    data
  })
}
// 修改用户组
export function updateTeamGroup(data) {
  return httpRequest.put({
    url: `/permission/team-group`,
    data
  })
}
// 删除用户组
export function delTeamGroup(data) {
  return httpRequest.delete({
    url: `/permission/team-group?ids[]=${data.ids}&teamId=${data.teamId}`
  })
}
// 将用户踢出用户组
export function removeFromTeam(data) {
  return httpRequest.get({
    url: `/permission/team-user/removeFromTeam?teamId=${data.teamId}&removeTeamUserId=${data.removeTeamUserId}`
  })
}
// 修改用户角色
export function changeTeamUserRole(data) {
  return httpRequest.get({
    url: `/permission/team-user/changeTeamUserRole?teamId=${data.teamId}&changeTeamUserId=${data.changeTeamUserId}&roleCode=${data.roleCode}`
  })
}
// 创建团队邀请连接
export function createTeamInviteCode(data) {
  return httpRequest.get({
    url: `/permission/team-invite-share-record/createTeamInviteCode?teamId=${data.teamId}`
  })
}
// 修改团队邀请
export function updateTeamInviteShare(data) {
  return httpRequest.post({
    url: `/permission/team-invite-share-record/updateTeamInviteShare`,
    data
  })
}
// 根据code查询邀请信息
export function getTeamInviteInfoByCode(data) {
  return httpRequest.get({
    url: `/permission/team-invite-share-record/getTeamInviteInfoByCode?code=${data.code}`
  })
}
// 加入用户组邀请
export function addInviteTeamUser(data) {
  return httpRequest.post({
    url: `/permission/team-user/addInviteTeamUser`,
    data
  })
}
// 退出团队
export function exitTeam(params) {
  return httpRequest.get({
    url: `/permission/team-user/exitTeam`,
    params
  })
}

// 分页查询团队用户列表
export function getTeamUserPage(params) {
  return httpRequest.get({
    url: `/permission/team-user/getTeamUserPage`,
    params
  })
}
// 移交团队
export function transferTeam(params) {
  return httpRequest.get({
    url: `/permission/team/transferTeam`,
    params
  })
}
// 查询团队用户列表-按分组 成员弹窗列表
export function getTeamUserList(params) {
  return httpRequest.get({
    url: `/permission/team-user/getTeamUserList`,
    params
  })
}
// 解散团队发送验证码
export function sendDissolveTeamVerifyCode(params) {
  return httpRequest.get({
    url: `/permission/team/sendDissolveTeamVerifyCode`,
    params
  })
}
// 修改用户下数智员工权限
export function updateTeamEmp(data) {
  console.log('data', data)
  return httpRequest.post({
    url: `/employee/emp-team-user/updateTeamEmp`,
    data
  })
}

// 查询当前团队下的数智员工
export function queryAllTeamEmpList(params) {
  return httpRequest.get({
    url: `/employee/order-detail-info/queryAllTeamEmpList`,
    params
  })
}

// 查询当前用户下数智员工
export function getTeamEmpList(params) {
  return httpRequest.get({
    url: `/employee/emp-team-user/getTeamEmpList`,
    params
  })
}

// 支付成功订单列表数据查询(个人和团队)
export function queryPackageList(params) {
  return httpRequest.get({
    url: `/payment/order-info/queryPackageList`,
    params
  })
}

// 订单详情列表(个人和团队)
export function queryOrderDetailList(params) {
  return httpRequest.get({
    url: `/payment/order-info/queryOrderDetailList`,
    params
  })
}

// 查询当前用户可以购买的数智员工(个人版)
export function userPayEmpList(params) {
  return httpRequest.get({
    url: `/payment/package-info/userPayEmpList`,
    params
  })
}

// 查询当前用户可以购买的数智员工(个人版)
export function teamPayEmpList(params) {
  return httpRequest.get({
    url: `/payment/package-info/teamPayEmpList`,
    params
  })
}
// 创建数智员工支付订单，返回支付链接
export function createStaffOrder(data) {
  console.log('data', data)
  return httpRequest.post({
    url: `/payment/user-package-info/createStaffOrder`,
    data
  })
}
// 校验优惠码使用
export function getInfoVoByCodea(data) {
  return httpRequest.get({
    url: `/payment/discount-code-info/getInfoVoByCode?code=${data.code}&discountType=${data.discountType}`
  })
}
// 查询用户团队角色
export function getUserTeamRole(params) {
  return httpRequest.get({
    url: `/permission/team-user/getUserTeamRole`,
    params
  })
}
// 根据code查询优惠码信息
export function getInfoVoByCode(params) {
  return httpRequest.get({
    url: `/payment/discount-code-info/getInfoVoByCode`,
    params
  })
}
// 查询团队成员积分消耗限额
export function closeOrder(params) {
  return httpRequest.get({
    url: `/payment/order-info/closeOrder`,
    params
  })
}
// 查询当前团队下的数智员工
export function queryTeamEmpDetailList(params) {
  return httpRequest.get({
    url: `/employee/order-detail-info/queryTeamEmpDetailList`,
    params
  })
}
// 分页查询待授权授权团队用户列表
export function getTeamUserListByEmpId(params) {
  return httpRequest.get({
    url: `/permission/team-user/getTeamUserListByEmpId`,
    params
  })
}
// 修改用户下数智员工权限-批量
export function updateTeamEmpList(data) {
  return httpRequest.post({
    url: `/employee/emp-team-user/updateTeamEmpList`,
    data
  })
}
// 查询团队数智员工详情
export function getTeamEmpPackageInfo(params) {
  return httpRequest.get({
    url: `/payment/package-info/getTeamEmpPackageInfo`,
    params
  })
}
// 取消团队用户数智员工权限
export function cancelEmpAuthorize(data) {
  return httpRequest.post({
    url: `/employee/emp-team-user/cancelEmpAuthorize`,
    data
  })
}
